import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/datasources/connectInspectFile';

const initialState = {
  response: null,
  isLoading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return { ...state, isLoading: true, error: null, response: null };
    case res:
      return { ...state, isLoading: false, response: action.payload };
    case fail:
      return { ...state, isLoading: false, error: action.payload };
    case clr:
      return { ...initialState };
    default:
      return state;
  }
};
